import ClaimKepConfirmation from "./ClaimKepConfirmation";

export default ClaimKepConfirmation;
